import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  label: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
}

export const SectionHeader = ({ label, title, subtitle, dark = false }: SectionHeaderProps) => (
  <div className={styles.header}>
    <p className={`${styles.label} ${dark ? '' : styles.labelLight}`}>{label}</p>
    <h2 className={`${styles.title} ${dark ? styles.titleDark : styles.titleLight}`}>{title}</h2>
    {subtitle && (
      <p className={`${styles.subtitle} ${dark ? styles.subtitleDark : styles.subtitleLight}`}>
        {subtitle}
      </p>
    )}
  </div>
);
